import axios from 'axios'
import { API_KEY, API_URL } from '../keys'
import UsersEntity from '@/entities/api/users/users'

export const userUpdateById = async (
	token: string,
	userId: string,
	data: Partial<UsersEntity>
) => {
	const response = await axios.patch(`${API_URL}/users/${userId}`, data, {
		headers: {
			Authorization: `Bearer ${token}`,
			'sce-api-users-key-validation': API_KEY,
			'Content-Type': 'application/json',
		},
		validateStatus: (status) => status < 500,
	})
	if (response) return response
}

export const fetchUsers = async (token: string) => {
	const response = await axios.get(`${API_URL}/users`, {
		headers: {
			Authorization: `Bearer ${token}`,
			'sce-api-users-key-validation': API_KEY,
			'Content-Type': 'application/json',
		},
		validateStatus: (status) => status < 500,
	})
	if (response) return response
}

export const removeUserById = async (token: string, userId: string) => {
	const response = await axios.delete(`${API_URL}/users/${userId}`, {
		headers: {
			Authorization: `Bearer ${token}`,
			'sce-api-users-key-validation': API_KEY,
			'Content-Type': 'application/json',
		},
		validateStatus: (status) => status < 500,
	})
	if (response) return response
}

export const createUser = async (
	token: string,
	file: File,
	data: Partial<UsersEntity>
) => {
	const formData = new FormData()
	formData.append('userData', JSON.stringify(data))
	formData.append('files', file)
	const response = await axios.post(`${API_URL}/users`, formData, {
		headers: {
			Authorization: `Bearer ${token}`,
			'sce-api-users-key-validation': API_KEY,
			'Content-Type': 'multipart/form-data',
		},
		validateStatus: (status) => status < 500,
	})
	if (response) return response
}
